import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import Logout from '@mui/icons-material/Logout';
import HelpIcon from '@mui/icons-material/Help';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';

const UserHeader = () => {
  const navigate = useNavigate();

  const lastName = localStorage.getItem('lastname');
  const firstName = localStorage.getItem('firstname');
  const initiales = firstName?.substring(0, 1) + lastName?.substring(0, 1);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = (event) => {
    handleClose();
    navigate('/deconnexion');
  };

  return (
    <div className="header-user">
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<HelpIcon />}
        onClick={() => window.open('https://houseofcoding.atlassian.net/servicedesk/customer/portal/73', '_blank')}
        sx={{ mr: 2 }}
      >
        Demande de support
      </Button>
      <IconButton
        size="small"
        sx={{ ml: 2 }}
        onClick={handleClick}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        aria-controls={open ? 'account-menu' : undefined}
      >
        <Avatar className="user-avatar">{initiales}</Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 37.5,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Déconnexion
        </MenuItem>
      </Menu>
    </div>
  );
}

export default UserHeader;